import Quize from './components/quize'
import './App.css'
function App() {
  return (
    <div className="App">
        <Quize/>
    </div>
  );
}

export default App;
